<template>
  <!-- BEGIN #modalPosItem -->
  <a-modal
    v-model="visible"
    :title="
      promotion_free_item_per_amount
        ? promotion_free_item_per_amount.promotion_name
        : ''
    "
    on-ok="handleOk"
  >
    <template slot="footer">
      <a-button key="back" @click="$emit('handle-cancel')">
        {{ $t('restaurantSale.cancel') }}
      </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="waiting"
        @click="$emit('handle-ok')"
      >
        {{ $t('restaurantSale.addFreeItem') }}
      </a-button>
    </template>
    <table
      id="list"
      class="table table-hover ui-table ts-table"
      v-if="conditions"
    >
      <thead>
        <tr>
          <th class="text-center">
            <ts-checkbox
              v-if="conditions.free_status == 'All'"
              @change="$emit('select-all', $event)"
              v-model="checkedAll"
            ></ts-checkbox>
          </th>
          <th class="ts-whitespace-no-wrap">
            {{ $t('restaurantSale.productName') }}
          </th>
          <th class="ts-whitespace-no-wrap text-center">
            {{ $t('restaurantSale.uom') }}
          </th>
          <th class="ts-whitespace-no-wrap text-center">
            {{ $t('restaurantSale.quantity') }}
          </th>
        </tr>
      </thead>
      <tbody v-if="conditions">
        <tr
          v-for="(record, index) in conditions.discount_items"
          :key="index"
        >
          <td class="text-center">
            <ts-checkbox
              v-if="conditions.free_status == 'All'"
              :value="{
                product_id: record.product_id,
                uom_id: record.uom_id,
                quantity: record.quantity
              }"
              v-model="selectedProductFree"
              @change="
                selectedProductFree.length ==
                conditions.discount_items.length
                  ? (checkedAll = true)
                  : (checkedAll = false)
              "
            ></ts-checkbox>
            <input
              v-if="conditions.free_status == 'Any'"
              type="radio"
              v-model="selectedProductFree"
              :value="[
                {
                  product_id: record.product_id,
                  uom_id: record.uom_id,
                  quantity: record.quantity
                }
              ]"
              :checked="
                selectedProductFree[0].product_id ==
                  record.product_id &&
                selectedProductFree[0].uom_id == record.uom_id &&
                selectedProductFree[0].quantity == record.quantity
                  ? true
                  : false
              "
            />
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.product_name_en }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.uom_name_en }}
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.quantity }}
          </td>
        </tr>
      </tbody>
    </table>
  </a-modal>
  <!-- END #modalPosItem -->
</template>

<script>
export default {
  name: 'PromotionModal',
  props: {
    visible: Boolean,
    promotion_free_item_per_amount: Object,
    conditions: Object,
    waiting: Boolean,
    selectedProductFree: Array,
    checkedAll: Boolean
  }
}
</script>

<style scoped>
.ant-modal-body {
  padding: 4px;
}
</style>